import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandDiagonal = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 5H19V10H17V7H14V5ZM10 17V19H5V14H7V17H10Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExpandDiagonal);
export { ForwardRef as ReactComponent };
